import React, { Component } from 'react';
import Profile from '../../components/developers/newprofile';
import loginAPI from '../../utils/ajax';
import swal from 'sweetalert';
import { getLocalItem } from '../../utils/cookies';
export default class profile extends Component {
  state = {
    render: false,
    response: '',
  };
  componentDidMount() {
    this.getProfile();
  }
  getProfile = async () => {
    const [response, error] = await loginAPI(
      'GET',
      'secure/angelbroking/user/v1/getProfile',
      {},
      {},
      { Authorization: 'Bearer ' + localStorage.getItem('jwtToken') }
    );
    if (response.status) {
      this.setState({ response: response.data }, () => {
        this.setState({ render: true });
      });
    } else {
      swal({
        text: response.message,
        icon: 'warning',
        dangerMode: true,
      });
    }
  };
  render() {
    return (
      <div id='SmartAPI-loader' style={{ height: '100vh' }}>
        {this.state.render ? (
          <Profile response={this.state.response} />
        ) : (
          <div id='load' class='loading' style={{ display: 'block' }}>
            asd
          </div>
        )}
      </div>
    );
  }
}
